const filterObject = (object, objectKeys, inputArray) => {
  const objectVals = objectKeys.map(key => object[key]);
  return objectVals.every(val => inputArray.indexOf(val) !== -1);
};

export function listIncludes(list, objectKeys, inputArray) {
  if (!inputArray.length) {
    return list;
  }

  return list.filter(object => filterObject(object, objectKeys, inputArray));
}
